// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';
import { scaleTime, scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';
import { area, line } from 'd3-shape';
import { extent, max } from 'd3-array';
import { axisBottom, axisLeft } from 'd3-axis';
import '../../../services/chart.service';
import '../common/chart-label';
import '../common/empty-results';

angular.module('directives.visualizations.timelineChart', ['services.ChartService'])
  .directive('timelineChart', [
    '$filter',
    'ChartService',
    function($filter, Chart) {
      return {
        restrict: 'E',

        template:
          '<empty-results ng-hide="timeline.length" message="emptyResultsText"></empty-results>' +
          '<div class="chart">' +
            '<chart-label position="label.position" visibility="label.visible" key="label.key" value="label.value" arrow="label.arrow">' +
            '</chart-label>' +
            '<svg></svg>' +
          '</div>',

        scope: {
          timeline: '=',
          chartTitle: '=',
          labelText: '=',
          emptyResultsText: '<'
        },
        link: function (scope, element) {
          // Container (to get the SVG tag and the size to center the chart)
          var container = element[0].querySelector('.chart');
          // SVG element, used to clean the chart
          var target = container.querySelector('svg');
          // D3 element, used to draw the chart and find bars
          var svg = select(target);
          // Dot size
          var dotSize = 5;
          // Left offset
          var left = 60;
          // Top offset
          var top = 20;

          scope.label = {
            arrow: true,
            position: {}
          };

          scope.labelDateFormat = 'MMMM yyyy';

          /**
           * Function to be executed on mouseover events, it shows a dot in the
           * specified area and fills the label object (and displays it)
           *
           * @param {string} key - Bar/Legend value key
           * @returns {undefined}
           */
          scope.mouseover = function(key) {
            var dot = svg.select('[data-id="' + key + '"]');
            var datum = dot.datum();

            // Show dot
            dot.classed('active', true);

            // Label properties
            var y = parseFloat(dot.attr('cy')) + top / 2 - dotSize;
            var x = parseFloat(dot.attr('cx')) + left;

            scope.label.visible = true;
            scope.label.key = $filter('date')(datum.key, scope.labelDateFormat);
            scope.label.value = devex.util.numberWithCommas(datum.value) +
                                (scope.labelText ? ' ' + scope.labelText : '');
            scope.label.position.top = y;
            scope.label.position.left = x;
          };

          /**
           * Function to be executed on mouseout events, it hides the dot of the
           * specified area and hides the label
           *
           * @param {string} key - Bar/Legend value key
           * @returns {undefined}
           */
          scope.mouseout = function(key) {
            var dot = svg.select('[data-id="' + key + '"]');

            // Hide dot
            dot.classed('active', false);

            // Label properties
            scope.label.visible = false;
          };

          var render = function() {
            // First we erase the content rendered on the SVG element
            Chart.erase(target);

            /**
             * SIZE
             */
            var size = Chart.getSize(container);
            var width = size.width - 70;
            var height = size.height - 70; // extra height for the legend (rotated)

            /**
             * CHART
             */
            var chart = svg.append('g')
              .attr('transform', 'translate(' + left + ', ' + top + ')');

            /**
             * AXIS
             */
            var x = scaleTime()
              .rangeRound([0, width])
              .domain(extent(scope.timeline, function(d) {
                return d.key;
              }));
            var y = scaleLinear()
              .rangeRound([height, 0])
              .domain([0, max(scope.timeline, function(d) {
                return d.value;
              }) + 50]);

            chart.append('g')
              .attr('class', 'axis axis-x')
              .attr('transform', 'translate(0, ' + height + ')')
              .call(axisBottom(x).ticks(5));

            chart.append('g')
              .attr('class', 'axis')
              .call(axisLeft(y).ticks(5).tickFormat(function(d) {
                return devex.util.numberToHumanAbbreviated(d);
              }));

            chart.append('text')
              .attr('class', 'units')
              .attr('x', 0)
              .attr('y', -10)
              .attr('text-anchor', 'end')
              .text(scope.chartTitle);

            /**
             * HORIZONTAL GRIDLINES
             */
            chart.append('g')
              .attr('class', 'grid')
              .call(axisLeft(y).ticks(5, '').tickSize(-width).tickFormat(''));

            /**
             * DOTS
             */
            var dots = svg.append('g')
              .attr('class', 'dots')
              .attr('transform', 'translate(' + left + ', ' + top + ')');

            dots.selectAll('dot')
              .data(scope.timeline)
              .enter()
              .append('circle')
              .attr('class', 'dot-area')
              .attr('r', width / scope.timeline.length / 2)
              .attr('cx', function(d) {
                return x(d.key);
              })
              .attr('cy', function(d) {
                return y(d.value);
              })
              .on('mouseover', function(_, d) {
                scope.$apply(function() {
                  scope.mouseover(d.key);
                });
              })
              .on('mouseout', function(_, d) {
                scope.$apply(function() {
                  scope.mouseout(d.key);
                });
              });

            dots.selectAll('dot')
              .data(scope.timeline)
              .enter()
              .append('circle')
              .attr('class', 'dot')
              .attr('r', dotSize)
              .attr('cx', function(d) {
                return x(d.key);
              })
              .attr('cy', function(d) {
                return y(d.value);
              })
              .attr('data-id', function(d) {
                return d.key;
              });

            /**
             * AREA
             */
            var areaShape = area()
              .x(function(d) {
                return x(d.key);
              })
              .y0(y(0))
              .y1(function(d) {
                return y(d.value);
              });

            var lineShape = line()
              .x(function(d) {
                return x(d.key);
              })
              .y(function(d) {
                return y(d.value);
              });

            chart.append('path')
              .attr('class', 'area')
              .datum(scope.timeline)
              .attr('d', areaShape);

            chart.append('path')
              .datum(scope.timeline)
              .attr('class', 'line')
              .attr('d', lineShape);
          };

          var renderWithData = function() {
            if(scope.timeline && scope.timeline.length) {
              render();
            }
          };

          renderWithData();

          scope.$watch('timeline', renderWithData);

          window.addEventListener('resize', renderWithData);

          scope.$on('$destroy', function() {
            window.removeEventListener('resize', renderWithData);
          });
        }
      };
    }
  ]);
